module.exports = __webpack_public_path__ + "static/media/minus.27093bfa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/minus.svg
// module id = 783
// module chunks = 0